import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, ShoppingBag, Star } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { toggleWishlist, isWishlisted } = useWishlist();
  const wishlisted = isWishlisted(product._id);
  const price = product.salePrice || product.price;
  const hasDiscount = product.salePrice && product.salePrice < product.price;

  return (
    <div style={{ position: 'relative', background: 'var(--dark-2)', border: '1px solid var(--border)', transition: 'border-color 0.3s, transform 0.3s', cursor: 'pointer' }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--border-hover)'; e.currentTarget.style.transform = 'translateY(-4px)'; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = 'translateY(0)'; }}
    >
      {/* Sale badge */}
      {hasDiscount && (
        <div style={{ position: 'absolute', top: '12px', left: '12px', zIndex: 2, background: 'var(--gold)', color: 'var(--black)', fontSize: '9px', fontWeight: 700, letterSpacing: '0.1em', padding: '3px 8px' }}>
          SALE
        </div>
      )}

      {/* Wishlist */}
      <button onClick={(e) => { e.preventDefault(); toggleWishlist(product._id); }}
        style={{ position: 'absolute', top: '12px', right: '12px', zIndex: 2, background: 'rgba(10,10,10,0.7)', border: '1px solid var(--border)', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: wishlisted ? 'var(--gold)' : 'var(--white-dim)', transition: 'all 0.3s', borderRadius: '50%' }}
      >
        <Heart size={14} fill={wishlisted ? 'var(--gold)' : 'none'} />
      </button>

      {/* Image */}
      <Link to={`/product/${product._id}`}>
        <div style={{ aspectRatio: '1', overflow: 'hidden', background: 'var(--dark-3)', position: 'relative' }}>
          {product.images?.[0] ? (
            <img src={product.images[0]} alt={product.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }}
              onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
              onMouseLeave={e => e.target.style.transform = 'scale(1)'}
            />
          ) : (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--white-faint)', fontFamily: 'var(--font-display)', fontSize: '14px', letterSpacing: '0.1em' }}>
              NO IMAGE
            </div>
          )}
        </div>
      </Link>

      {/* Info */}
      <div style={{ padding: '16px' }}>
        <p style={{ fontSize: '10px', color: 'var(--gold)', letterSpacing: '0.15em', marginBottom: '6px', fontWeight: 500 }}>{product.brand?.toUpperCase()}</p>
        <Link to={`/product/${product._id}`}>
          <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '18px', fontWeight: 500, color: 'var(--white)', marginBottom: '8px', lineHeight: 1.2 }}>{product.name}</h3>
        </Link>

        {/* Rating */}
        {product.numReviews > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '12px' }}>
            <div style={{ display: 'flex', gap: '2px' }}>
              {[1,2,3,4,5].map(s => (
                <Star key={s} size={10} fill={s <= Math.round(product.rating) ? 'var(--gold)' : 'none'} color={s <= Math.round(product.rating) ? 'var(--gold)' : 'var(--white-faint)'} />
              ))}
            </div>
            <span style={{ fontSize: '10px', color: 'var(--white-dim)' }}>({product.numReviews})</span>
          </div>
        )}

        {/* Price + Cart */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <span style={{ fontSize: '18px', fontFamily: 'var(--font-display)', color: hasDiscount ? 'var(--gold)' : 'var(--white)' }}>${price}</span>
            {hasDiscount && <span style={{ fontSize: '13px', color: 'var(--white-faint)', textDecoration: 'line-through', marginLeft: '8px' }}>${product.price}</span>}
          </div>
          <button onClick={() => addToCart(product._id, 1, product.size?.[0])}
            style={{ background: 'var(--gold)', color: 'var(--black)', border: 'none', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.3s', cursor: 'pointer' }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--gold-light)'}
            onMouseLeave={e => e.currentTarget.style.background = 'var(--gold)'}
            disabled={product.countInStock === 0}
          >
            <ShoppingBag size={14} />
          </button>
        </div>

        {product.countInStock === 0 && (
          <p style={{ fontSize: '10px', color: '#ef4444', marginTop: '6px', letterSpacing: '0.1em' }}>OUT OF STOCK</p>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
